// Role constants
export const Role = {
    ADMIN: { value: 'ADMIN', label: 'Administrateur' },
    MANAGER: { value: 'MANAGER', label: 'Manager' },
    SALES_REP: { value: 'SALES_REP', label: 'Commercial' },
    //DISTRIBUTOR: { value: 'DISTRIBUTOR', label: 'Distributeur' },
    //WAREHOUSE_MANAGER: { value: 'WAREHOUSE_MANAGER', label: 'Manager entrepot' },
};

// Client types
export const ClientType = {
    DISTRIBUTOR: { value: 'DISTRIBUTOR', label: 'Distributeur' },
    RETAILER: { value: 'RETAILER', label: 'Revendeur' } 
};

// Navigation items
export const NAV_ITEMS = [
    {
        label: 'Tableau de bord',
        path: '/dashboard',
        icon: 'LayoutDashboard',
        roles: ['ADMIN', 'MANAGER', 'SALES_REP', 'WAREHOUSE_MANAGER', 'DISTRIBUTOR'],
    },
    {
        label: 'Magasins',
        path: '/buildings',
        icon: 'Building2',
        roles: ['ADMIN', 'MANAGER']
    },
    {
        label: 'Zones',
        path: '/zones',
        icon: 'MapPin',
        roles: ['ADMIN', 'MANAGER']
    },
    {
        label: 'Produits',
        path: '/products',
        icon: 'ShoppingBag',
        roles: ['ADMIN', 'MANAGER', 'SALES_REP', 'WAREHOUSE_MANAGER', 'DISTRIBUTOR'],
    },
    {
        label: 'Partenaires',
        path: '/partners',
        icon: 'Users',
        roles: ['ADMIN', 'MANAGER'],
        hasDropdown: true,
        children: [
            // {
            //     label: 'Fournisseurs',
            //     path: '/suppliers',
            //     icon: 'Truck',
            //     roles: ['ADMIN', 'MANAGER', 'WAREHOUSE_MANAGER'],
            // },
            {
                label: 'Distributeurs',
                path: '/distributors',
                icon: 'ShoppingBag',
                roles: ['ADMIN', 'MANAGER']
            },
            {
                label: 'Revendeurs',
                path: '/retailers',
                icon: 'Store',
                roles: ['ADMIN', 'MANAGER', 'SALES_REP']
            }
        ]
    },

    {
        label: 'Revendeurs',
        path: '/retailers',
        icon: 'Store',
        roles: ['SALES_REP']
    },
    {
        label: 'Commandes',
        path: '/orders',
        icon: 'ClipboardList',
        roles: ['ADMIN', 'MANAGER', 'SALES_REP', 'WAREHOUSE_MANAGER', 'DISTRIBUTOR'],
    },
    {
        label: 'Bon de livraison',
        path: '/delivery-notes',
        icon: 'ClipboardList',
        roles: ['ADMIN', 'MANAGER'],
    },
    // {
    //     label: 'Stock',
    //     path: '/inventory',
    //     icon: 'Layers',
    //     roles: ['ADMIN', 'MANAGER', 'WAREHOUSE_MANAGER'],
    // },
    {
        label: 'Factures',
        path: '/invoices',
        icon: 'ClipboardList',
        roles: ['ADMIN', 'MANAGER', 'DISTRIBUTOR'],   
    },
    {
        label: 'Utilisateurs',
        path: '/users',
        icon: 'UserCog',
        roles: ['ADMIN', 'MANAGER'],
    },
    {
        label: 'Rapports',
        path: '/reports',
        icon: 'BarChart2',
        roles: ['ADMIN', 'MANAGER'],
    },
];